export default "__VITE_ASSET__f7zR7aGq__"